module.exports = __webpack_public_path__ + "img/qyyy.32dbeb12.32dbeb12.jpg";